var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('Header',{attrs:{"title":_vm.itemTitle}}),_c('div',{staticClass:"container dashboard card"},[_c('div',{staticClass:"item-body"},[_vm._v(" "+_vm._s(_vm.content)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }